import type { Role } from '../types/person';

/**
 * Numeric rank for each role in the hierarchy. Higher number = more privilege.
 * Used by Cloud Functions to enforce that callers cannot assign roles above
 * their own level (e.g., an organizer cannot create an admin user).
 *
 * Hierarchy: admin > organizer > internal > invitee > companion
 *
 * "Speaker" is not a role; it is a relationship to a session via
 * session.speakerIds[]. Any role can speak at a session.
 */
export const ROLE_RANK: Record<Role, number> = {
  companion: 0,
  invitee: 1,
  internal: 2,
  organizer: 3,
  admin: 4,
};
